import React from 'react';

/**
 * WalkthroughOverlay Component
 * Creates a spotlight effect using box-shadow to highlight the current step's target element
 */
const WalkthroughOverlay = ({ elementRect, padding = 8 }) => {
  if (!elementRect) {
    return null;
  }

  const highlightStyle = {
    position: 'fixed',
    top: elementRect.top,
    left: elementRect.left,
    width: elementRect.width,
    height: elementRect.height,
    boxShadow: '0 0 0 9999px rgba(0, 0, 0, 0.6)',
    border: '3px solid #0176d3',
    borderRadius: '4px',
    transition: 'all 0.3s ease-in-out',
    pointerEvents: 'none',
    zIndex: 9998
  };

  return <div style={highlightStyle} />;
};

export default WalkthroughOverlay;
